const Routes_gral = {
    login: '/',
    home: '/Home',
    user: '/User',
    group: '/Group',
    product: '/Product',
    addReq: '/addReq'
}

export default Routes_gral